import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Docs from "./pages/Docs";
import { useEffect, useState } from "react";

// A component to handle external redirects
const RedirectComponent = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};

function App() {
  const [location, setLocation] = useState("");

  useEffect(() => {
    const currHost = window.location.hostname;
    setLocation(currHost);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Check if the hostname includes 'flicktest or joslery' */}
        {location.includes("flicktest") ? (
          <Route
            path="/login"
            element={<RedirectComponent url="https://www.flicktest.com/login" />}
          />
        ) : (
          <Route
            path="/login"
            element={<RedirectComponent url="https://www.joslery.com/login" />}
          />
        )}

        {location.includes("flicktest") ? (
          <Route
            path="/register"
            element={
              <RedirectComponent url="https://www.flicktest.com/register" />
            }
          />
        ) : (
          <Route
            path="/register"
            element={
              <RedirectComponent url="https://www.joslery.com/register" />
            }
          />
        )}

        {/* Internal redirects */}
        <Route
          path="/docs/apis"
          element={<Navigate to="/apis/api-overview" />}
        />
        <Route path="/apis" element={<Navigate to="/apis/api-overview" />} />
        <Route path="/apis/:apiRoute" element={<Docs />} />
        <Route
          path="/"
          element={<Navigate to="/docs/getting-started/introduction" />}
        />
        <Route
          path="/docs"
          element={<Navigate to="/docs/getting-started/introduction" />}
        />

        {/* Route with dynamic path parameter `:docsItem` */}
        <Route path="/docs/:doctype/:docsItem" element={<Docs />} />
      </Routes>
    </Router>
  );
}

export default App;
